import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { SEOHead } from '@/components/SEOHead';
import { useLanguage } from '@/contexts/LanguageContext';
import logo from '@/assets/gaius-logo.webp';
import { Heart } from 'lucide-react';

export const AccountDeletedPage = () => {
  const { language } = useLanguage();
  const fr = language === 'fr';

  return (
    <div className="min-h-screen bg-secondary/30 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <SEOHead
        title={fr ? "Compte supprimé | Gaius" : "Account Deleted | Gaius"}
        description={fr ? "Votre compte Gaius a été supprimé" : "Your Gaius account has been deleted"}
      />
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <Link to="/">
            <img src={logo} alt="Gaius" className="h-16 lg:h-20 mx-auto mb-4" />
          </Link>
        </div>
        <Card className="border-border shadow-lg">
          <CardContent className="pt-8 pb-8 text-center space-y-6">
            <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
              <Heart className="w-8 h-8 text-primary" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-foreground mb-2">
                {fr ? 'Votre compte a été supprimé' : 'Your account has been deleted'}
              </h1>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {fr
                  ? 'Nous sommes tristes de vous voir partir, mais nous respectons votre choix.'
                  : 'We\'re sad to see you go, but we respect your choice.'}
              </p>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed">
              {fr
                ? 'Toutes vos données ont été supprimées conformément au RGPD. Si vous changez d\'avis, vous serez toujours le bienvenue chez Gaius !'
                : 'All your data has been deleted in compliance with GDPR. If you change your mind, you\'ll always be welcome back at Gaius!'}
            </p>
            <div className="space-y-3">
              <Button asChild className="w-full">
                <Link to="/">
                  {fr ? 'Retour à l\'accueil' : 'Back to home'}
                </Link>
              </Button>
              <p className="text-xs text-muted-foreground">
                {fr ? 'Merci d\'avoir fait partie de l\'aventure Gaius.' : 'Thank you for being part of the Gaius journey.'}
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
